import { RevCard } from "@revmatics/catalyst";
import { PersonaAudience } from "./components/personaAudience/PersonaAudience.tsx";
import { InterestAudience } from "./components/interestAudience/InterestAudience.tsx";

export const MediaPlanAudience = () => {
  return (
    <RevCard className="px-4! pb-4! pt-2.5">
      <h6 className="mb-2.5">Audience</h6>
      <div className="space-y-4">
        <PersonaAudience />
        <InterestAudience />
      </div>
    </RevCard>
  );
};
